import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const MobileAppBanner = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section className="py-20 bg-gradient-to-br from-foodsply-green to-foodsply-orange overflow-hidden">
      <div className="container mx-auto px-4" ref={ref}>
        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="text-white order-2 lg:order-1"
          >
            <div className="flex items-center mb-6">
              <div className="bg-white rounded-lg p-2">
                <img src="/images/logo.svg" alt="FoodSply" className="h-12" />
              </div>
            </div>
            
            <h2 className="text-3xl md:text-4xl font-display font-bold mb-6">
              Discover the freshest agricultural products with FOODSPLY, now on mobile!
            </h2>
            
            <p className="text-xl mb-8 opacity-90 leading-relaxed">
              Download now on Google Play or the Apple Store and connect directly 
              with the farm-to-table experience.
            </p>

            {/* App Store Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <motion.a
                href="#"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="inline-flex items-center bg-black text-white px-6 py-3 rounded-xl font-semibold hover:bg-gray-800 transition-colors"
              >
                <img src="/images/google_play.svg" alt="Google Play" className="w-8 h-8 mr-3" />
                <div>
                  <div className="text-xs opacity-80">GET IT ON</div>
                  <div className="text-lg font-bold">Google Play</div>
                </div>
              </motion.a>
              
              <motion.a
                href="#"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="inline-flex items-center bg-black text-white px-6 py-3 rounded-xl font-semibold hover:bg-gray-800 transition-colors"
              >
                <img src="/images/apple.svg" alt="App Store" className="w-8 h-8 mr-3" />
                <div>
                  <div className="text-xs opacity-80">Download on the</div>
                  <div className="text-lg font-bold">App Store</div>
                </div>
              </motion.a>
            </div>

            {/* Features */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.3 }}
              className="mt-12 grid sm:grid-cols-2 gap-6"
            >
              <div className="flex items-center">
                <div className="w-3 h-3 bg-white rounded-full mr-3"></div>
                <span className="text-white opacity-90">Direct farmer connections</span>
              </div>
              <div className="flex items-center">
                <div className="w-3 h-3 bg-white rounded-full mr-3"></div>
                <span className="text-white opacity-90">Fresh product marketplace</span>
              </div>
              <div className="flex items-center">
                <div className="w-3 h-3 bg-white rounded-full mr-3"></div>
                <span className="text-white opacity-90">Real-time inventory tracking</span>
              </div>
              <div className="flex items-center">
                <div className="w-3 h-3 bg-white rounded-full mr-3"></div>
                <span className="text-white opacity-90">Secure blockchain payments</span>
              </div>
            </motion.div>
          </motion.div>

          {/* Right Content - Mobile App Image */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative order-1 lg:order-2 flex justify-center"
          >
            <div className="relative">
              <img 
                src="/images/foodsply.png" 
                alt="FoodSply Mobile App" 
                className="w-80 h-[600px] object-contain shadow-2xl"
              />

              {/* Floating Elements */}
              <motion.div
                animate={{ y: [0, -10, 0] }}
                transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
                className="absolute -top-4 -left-4 w-16 h-16 bg-white/20 rounded-full backdrop-blur-sm flex items-center justify-center"
              >
                <img src="/images/lightbulb-white.svg" alt="" className="w-8 h-8" />
              </motion.div>

              <motion.div
                animate={{ y: [0, 10, 0] }}
                transition={{ duration: 3, repeat: Infinity, ease: "easeInOut", delay: 1.5 }}
                className="absolute -bottom-4 -right-4 w-16 h-16 bg-white/20 rounded-full backdrop-blur-sm flex items-center justify-center"
              >
                <img src="/images/shield-white.svg" alt="" className="w-8 h-8" />
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default MobileAppBanner;